import { createFileRoute } from '@tanstack/react-router'
import { CreateAllergyPage } from '_/features/pets/ui/pages/create-allergy-page'

const CreateAllergyRoute = () => {
	const { petId } = Route.useParams()
	return <CreateAllergyPage petId={petId} />
}

export const Route = createFileRoute('/_authenticated/pets/$petId/allergies/create')({
	staticData: { title: 'allergies_create_title' },
	component: CreateAllergyRoute,
})
